import investReducers from 'features/invest/reducers';
import pots from 'features/pots/reducers/pots';
import unpersistedPotsReducer from 'features/pots/reducers/unpersistedPotsReducer';
import wealth from 'features/wealth/reducers';
import { myLimits } from 'features/settings/plan-overview/reducers/myLimits';
import { spaces } from 'features/spaces/reducers';
import { referrals } from 'features/inviteFriend/reducers';
import { helpArticles } from 'features/help/reducers';
import { contacts } from 'features/contacts/reducers';
import { iapSubscriptions, stripe } from 'features/premium/reducers';
import subscriptions from 'features/subscriptions/reducers';
import notifications from 'features/notifications/reducers';
import analytics from 'features/analytics/reducers';
import signInNavigation from 'login/reducers/signinNavigation';
import { promotionsReducer } from 'features/promotions/reducers';
import { smartRules } from 'features/smart-rules/reducers';
import creditScoreOnboarding from 'features/credit-score/reducers/creditScoreOnboarding';
import monevoOnboarding from 'features/borrow/monevo/reducers/monevoOnboarding';
import creditScore from 'features/credit-score/reducers/creditScore';
import creditReport from 'features/credit-score/reducers/creditReport';
import enhancedFactors from 'features/credit-score/reducers/enhancedFactors';
import creditAlerts from 'features/credit-score/reducers/creditAlerts';
import creditScoreHistory from 'features/credit-score/reducers/creditScoreHistory';
import nordVpn from 'features/NordVpn/reducers';
import rentReporting from 'features/rent-reporting/reducers';
import streaks from 'features/streaks/reducers';
import onboardingInsights from 'features/onboarding-insights/reducers';
import budgeting from 'features/budgeting/reducers';
import paymentLimits from 'features/pay/reducers/paymentLimits';
import preApprovedTransfers from 'features/pre-approved-transfers/reducers';
import paymentsV2 from 'features/pay/reducers/paymentsV2';
import exportData from 'features/export-data/reducers';
import liveSheet from 'features/export-data-live/reducers';
import setUpEmma from 'features/setUpEmma/reducer';
import feed from './feed';
import groups from './groups';
import accounts from './accounts';
import user from './user';
import linkBank from './linkBank';
import transactions from './transactions';
import utils from './utils';
import error from './error';
import expenses from './expenses';
import quiz from './quiz';
import rewards from './rewards';
import quests from '../features/quests/reducers';
import reports from './reports';
import switching from './switching';
import recommendations from './recommendations';
import dataProtection from './dataProtection';
import payments from './payments';
import pendingPayments from './pendingPayments';
import thankedPayment from './thankedPayment';
import remindedRequest from './remindedRequest';
import beneficiaries from './beneficiaries';
import sharedBills from './sharedBills';
import eventBus from './eventBus';
import signIn from './signin';
import signInWeb from './signinWeb';
import { network } from './network';
import deviceSettings from './deviceSettings';
import sessionSettings from './sessionSettings';
import balanceHistory from './balanceHistory';
import billingHistory from '../features/premium/reducers/billingHistory';
import unpersistedUtils from './unpersistedUtils';
import addressReducer from './address';
import walkthrough from './walkthrough';
import unpersistedTransactions from './unpersistedTransactions';
import sharedPlans from './sharedPlans';
export default {
    feed,
    groups,
    accounts,
    user,
    linkBank,
    transactions,
    unpersistedTransactions,
    utils,
    error,
    expenses,
    subscriptions,
    quiz,
    rewards,
    quests,
    reports,
    switching,
    recommendations,
    notifications,
    dataProtection,
    payments,
    pendingPayments,
    thankedPayment,
    remindedRequest,
    spaces,
    myLimits,
    beneficiaries,
    sharedBills,
    eventBus,
    unpersistedUtils,
    ...investReducers,
    network,
    signIn,
    signInWeb,
    contacts,
    pots,
    wealth,
    addressReducer,
    stripe,
    balanceHistory,
    billingHistory,
    unpersistedPotsReducer,
    iapSubscriptions,
    deviceSettings,
    sessionSettings,
    setUpEmma,
    analytics,
    promotionsState: promotionsReducer,
    signInNavigation,
    smartRules,
    rentReporting,
    streaks,
    onboardingInsights,
    budgeting,
    paymentLimits,
    referrals,
    helpArticles,
    preApprovedTransfers,
    walkthrough,
    paymentsV2,
    exportData,
    sharedPlans,
    liveSheet,
    nordVpn,
    creditScoreOnboarding,
    creditScore,
    creditReport,
    enhancedFactors,
    creditAlerts,
    creditScoreHistory,
    monevoOnboarding,
};
